import { render, staticRenderFns } from "./resourceDetailAllocationUser.vue?vue&type=template&id=e44eedcc&scoped=true"
import script from "./resourceDetailAllocationUser.vue?vue&type=script&lang=js"
export * from "./resourceDetailAllocationUser.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailAllocationUser.vue?vue&type=style&index=0&id=e44eedcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44eedcc",
  null
  
)

export default component.exports